import { navigate } from "gatsby-link";
import React, { useEffect, useState } from "react";
import Cookies from 'universal-cookie';
import Loader from "./Loader";
import Header from "./Header";
import axios from "axios";
import { profiles, getProfileData, authenticateProfile, isProtected, updateAccount } from "../urls";
import { Modal } from '@mui/material'
import {
    PinInput,
    PinInputField
} from "@chakra-ui/pin-input"
 
const cookies = new Cookies();

const Wrapper = ({ children }) => {
    const [profilesData, setProfilesData] = useState(null);
    const [selectedProfile, setSelectedProfile] = useState(null);
    const [openNewPinModal, setOpenNewPinModal] = useState(false);
    
    const handleOpenNewPinModal = () => setOpenNewPinModal(true);
    const handleCloseNewPinModal = () => setOpenNewPinModal(false);

    const handleNewPinComplete = (value) => {
        axios.post(updateAccount, {
            'code': cookies.get('code'),
            'prof_code': cookies.get('prof_code'),
            'pin': value
        })
        .then(res => {
            handleCloseNewPinModal();
        })
        .catch(err => console.error(err))
    } 

    useEffect(() => {
        axios.post(profiles,{
        'code': cookies.get('code')
        })
        .then(res => {
        setProfilesData(res.data.profiles);
        if(res.data.profiles.length === 1 && selectedProfile !== res.data.profiles[0]) {
            setSelectedProfile(res.data.profiles[0]);
            axios.post(authenticateProfile, {
                'code': cookies.get('code'),
                'id': res.data.profiles[0].id
            })
            .then(res => cookies.set('prof_code', res.data.resp, { path: '/', expires: new Date(Date.now()+31536000000) }))
            .catch(err => console.error(err))
        } else if (res.data.profiles.length && selectedProfile !== res.data.profiles[0]) {
            if (cookies.get('prof_code')) {
                axios.post(getProfileData, {
                    'code': cookies.get('code'),
                    'prof_code': cookies.get('prof_code')
                })
                .catch(err => {
                    console.error(err);/* eslint-disable no-unused-expressions */
                    typeof window !== "undefined" ? navigate('/select-profile') : null
                })
            }
        }
        })
        .catch(err => console.error(err))
    }, [])

    useEffect(() => {
        axios.post(isProtected, {
          'code': cookies.get('code'),
          'prof_code': cookies.get('prof_code')
        })
        .then(res => {
          if(!res.data.protected){
            handleOpenNewPinModal();
          }
        })
      }, []);

    return <div>
        {cookies.get('code') ? (
            profilesData ? (
                profilesData.length ? (
                    cookies.get('prof_code') ? <div className="main-wrapper">
                    <Header profiles={selectedProfile} />
                    <title>Home - Teserakt</title>
                    <Modal
                        open={openNewPinModal}
                        onClose={handleCloseNewPinModal}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                        className="profile-modal-body"
                    >
                        <div className="profile-modal">
                            <div className="profile-help-text help-text-username">First Set a 4 Digit Pin for your Profile</div>
                            <div className="pin-holder">
                                <PinInput onComplete={handleNewPinComplete}>
                                    <PinInputField autoFocus />
                                    <PinInputField />
                                    <PinInputField />
                                    <PinInputField />
                                </PinInput>
                            </div>
                        </div>
                    </Modal>
                    <div className="body-between-head-and-foot">
                        {children}
                    </div>
                </div> : <Loader>{typeof window !== "undefined" ? navigate('/select-profile'): null}</Loader>
                ) : <Loader>{typeof window !== "undefined" ? navigate('/create-og'): null}</Loader>
            ) : null
        ) :
            <Loader>{typeof window !== "undefined" ? navigate('/login'): null}</Loader>
        }
    </div>
}

export default Wrapper